import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'manufacturerinfo',
  templateUrl: './manufacturerinfo.component.html',
  styleUrls: ['./manufacturerinfo.component.css']
})
export class ManufacturerinfoComponent implements OnInit {

  constructor() { }

  checkAllManufacturerInfo = false;

  url;
  urlChecked = false;

  sdsURL;
  sdsURLChecked = false;

  contactLocation;
  contactLocationChecked = false;

  // contactEmail;
  // contactEmailChecked = false;

  // contactUrl;
  // contactUrlChecked = false;

  contactDetails;
  contactDetailsChecked = false;

  // phoneNumber;
  // phoneNumberChecked = false;

  // faxNumber;
  // faxNumberChecked = false;

  effectiveContactMethod;
  effectiveContactMethodChecked = false;


  ngOnInit() {
  }

  onUrlChecked() {
    this.url = '';
    if (this.urlChecked) {
      this.url = 'URL';
    }
  }

  onSDSURLChecked() {
    this.sdsURL = '';
    if (this.sdsURLChecked) {
      this.sdsURL = 'SDS_URL';
    }
  }

  onContactLocationChecked() {
    this.contactLocation = '';
    if (this.contactLocationChecked) {
      this.contactLocation = 'ContactLocation';
    }
  }

  // onContactEmailChecked() {
  //   this.contactEmail = '';
  //   if (this.contactEmailChecked) {
  //     this.contactEmail = 'ContactEmail';
  //   }
  // }

  // onContactUrlChecked() {
  //   this.contactUrl = '';
  //   if (this.contactUrlChecked) {
  //     this.contactUrl = 'ContactURL';
  //   }
  // }

  // onPhoneNumberChecked() {
  //   this.phoneNumber = '';
  //   if (this.phoneNumberChecked) {
  //     this.phoneNumber = 'PhoneNumber';
  //   }
  // }

  // onFaxNumberChecked() {
  //   this.faxNumber = '';
  //   if (this.faxNumberChecked) {
  //     this.faxNumber = 'FaxNumber';
  //   }
  // }

  onContactDetailsChecked() {
    this.contactDetails = '';
    if (this.contactDetailsChecked) {
      this.contactDetails = 'ContactDetails';
    }
  }

  onEffectiveContactMethodChecked() {
    this.effectiveContactMethod = '';
    if (this.effectiveContactMethodChecked) {
      this.effectiveContactMethod = 'EffectiveContactMethods';
    }
  }

  onSelectAllManufacturerInfoClick(event) {
    if (event.checked) {
      this.urlChecked = true;
      if (this.urlChecked) {
        this.onUrlChecked();
      }
      this.sdsURLChecked = true;
      if (this.sdsURLChecked) {
        this.onSDSURLChecked();
      }
      // this.contactUrlChecked = true;
      // if (this.contactUrlChecked) {
      //   this.onContactUrlChecked();
      // }
      this.contactLocationChecked = true;
      if (this.contactLocationChecked) {
        this.onContactLocationChecked();
      }
      // this.phoneNumberChecked = true;
      // if (this.phoneNumberChecked) {
      //   this.onPhoneNumberChecked();
      // }
      // this.faxNumberChecked = true;
      // if (this.faxNumberChecked) {
      //   this.onFaxNumberChecked();
      // }
      this.contactDetailsChecked = true;
      if (this.contactDetailsChecked) {
        this.onContactDetailsChecked();
      }
      // this.contactEmailChecked = true;
      // if (this.contactEmailChecked) {
      //   this.onContactEmailChecked();
      // }
      this.effectiveContactMethodChecked = true;
      if (this.effectiveContactMethodChecked) {
        this.onEffectiveContactMethodChecked();
      }
    } else {

      this.urlChecked = false;
      this.url = '';
      this.sdsURLChecked = false;
      this.sdsURL = '';
      // this.contactUrlChecked = false;
      // this.contactUrl = '';
      // this.phoneNumberChecked = false;
      // this.phoneNumber = '';
      // this.faxNumberChecked = false;
      // this.faxNumber = '';
      this.contactLocationChecked = false;
      this.contactLocation = '';
      this.contactDetailsChecked = false;
      this.contactDetails = '';
      // this.contactEmailChecked = false;
      // this.contactEmail = '';
      this.effectiveContactMethodChecked = false;
      this.effectiveContactMethod = '';
    }
  }

  getCheckedValues() {
    const result = [];
    if (this.urlChecked) { result.push(this.url); }
    if (this.sdsURLChecked) { result.push(this.sdsURL); }
    // if (this.contactUrlChecked) { result.push(this.contactUrl); }
    // if (this.phoneNumberChecked) { result.push(this.phoneNumber); }
    // if (this.faxNumberChecked) { result.push(this.faxNumber); }
    if (this.contactLocationChecked) { result.push(this.contactLocation); }
    if (this.contactDetailsChecked) { result.push(this.contactDetails); }
    // if (this.contactEmailChecked) { result.push(this.contactEmail); }
    if (this.effectiveContactMethodChecked) { result.push(this.effectiveContactMethod); }
    return result;
  }

}
